import React from 'react';
import { useSelector } from 'react-redux';
import Loader from '@cpg-its/ads.common.loading-circle';
import { useQuery } from '../../../../../global/hooks/useQuery';
import { TcsmStates } from '../../../../../root/tcsm-model';
import { InstitutionState } from '../institution-model';
import { usePlanSummary } from '../plan-summary/usePlanSummary';
import { PensionPlanTypes } from './plan-history-models';
import DbPlanHistory from './db-plan-history';
import { InstitutionProps } from '../../../models/arc-epi-props';
import DcRsvpPlanHistory from './dc-rsvp-plan-history';



function PlanHistory() {


	const planType = useQuery().get('type') as PensionPlanTypes;
	const institutionState = useSelector<TcsmStates, InstitutionState>(state => state.institutionState);
	const summaryPlanLoaded = usePlanSummary(institutionState?.institutionClientNumber);
	const settings = useSelector<TcsmStates, InstitutionProps>(state => state.epiProps?.institutionSettingsState?.epiContent);


	if (!summaryPlanLoaded) {
		return <Loader />;
	}


	switch (planType) {
		case PensionPlanTypes.ClergyDb:
			return <DbPlanHistory
				planName={settings?.clergyDbSectionTitle}
				searchId={`clergydb${institutionState?.currentInstitution?.org_client_nbr}`}
				planHistory={institutionState?.planSummary?.clergy_db?.active?.concat(institutionState?.planSummary?.clergy_db?.terminated)}
			/>;
		case PensionPlanTypes.LayDb:
			return <DbPlanHistory
				planName={settings?.layDbSectionTitle}
				searchId={`laydb${institutionState?.currentInstitution?.org_client_nbr}`}
				planHistory={institutionState?.planSummary?.lay_db?.active?.concat(institutionState?.planSummary?.lay_db?.terminated)}
			/>;
		case PensionPlanTypes.LayDc:
			return <DcRsvpPlanHistory
				planType={PensionPlanTypes.LayDc}
				activePlanId={institutionState?.planSummary?.dc?.active[0]?.id}
				terminatedPlanId={institutionState?.planSummary?.dc?.terminated[0]?.id}
			/>;
		case PensionPlanTypes.Rsvp:
			return <DcRsvpPlanHistory
				planType={PensionPlanTypes.Rsvp}
				activePlanId={institutionState?.planSummary?.rsvp?.active[0]?.id}
				terminatedPlanId={institutionState?.planSummary?.rsvp?.terminated[0]?.id}
			/>;
		default:
			return null;

	}
}

export default PlanHistory;